module.exports = __webpack_public_path__ + "img/bgr-valentine.b6ca5db8.svg";